import { Box, Flex } from "@chakra-ui/react";
import { Select, Tag } from "antd";

const tagRender = (props) => {
  const { label, onClose } = props;
  const onPreventMouseDown = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };
  return (
    <Tag
      // color={"blue"}
      onMouseDown={onPreventMouseDown}
      // style={{
      //   marginRight: 3,
      // }}
      style={{padding:0,borderRadius:"5px"}}
    >
      <Flex justifyContent="space-between" alignItems={"center"} gap={4} bg="rgba(0,141,219,0.26)" borderRadius={"5px"} px={1}>
        <Box color="black">{label} </Box>
        <Box
          bg={"rgba(0,141,219)"}
          m={1}
          w={"20px"}
          h={"18px"}
          borderRadius={"10px"}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          cursor={"pointer"}
          color={"white"}
          fontSize="12px"
          onClick={onClose}
        >
          X
        </Box>
      </Flex>
    </Tag>
  );
};
const TagsInput = () => (
  <Select
    mode="tags"
    showArrow
    tagRender={tagRender}
    className="tag_input_gigpost"
    style={{
      width: "100%",
    }}
    suffixIcon={null}
    // options={options}
    maxLength={5}
  />
);
export default TagsInput;
